import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Container } from "./common";

const BADGES = [
  { k: "STPS", v: "Agente capacitador oficial" },
  { k: "LGEC", v: "Marco vigente · DOF 2026" },
  { k: "2 brazos", v: "Commerce + Carbono" },
  { k: "ODS ×5", v: "2 · 8 · 11 · 12 · 17" },
];

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden rc-grain" data-testid="hero">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1769751332240-88d025f76e62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Bosque de niebla de Xalapa, Veracruz"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-rc-bg/80 via-rc-bg/70 to-rc-bg" />
        <div className="absolute -top-40 -left-40 w-[40rem] h-[40rem] rounded-full bg-rc-forest/20 blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[30rem] h-[30rem] rounded-full bg-rc-terra/10 blur-[120px]" />
      </div>

      <Container className="relative z-10 pt-28 pb-20">
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="rc-eyebrow"
        >
          Xalapa, Veracruz · Desde 2026
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 max-w-4xl font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight text-stone-100"
        >
          El problema no es el mercado.
          <br />
          Es el <em className="text-rc-sage" style={{ fontStyle: "italic" }}>aislamiento.</em>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-8 max-w-2xl text-lg sm:text-xl text-stone-300 font-light leading-relaxed"
        >
          Raíz Commerce articula comercio, economía circular y turismo en una sola
          arquitectura territorial — para que lo que un productor, un municipio o un
          comercio hace por separado, empiece a sumar junto.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 flex flex-wrap gap-4"
        >
          <a
            href="/#contacto"
            data-testid="hero-diagnostico-btn"
            className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-rc-forest hover:bg-rc-forestlight text-stone-100 transition-colors"
          >
            Agenda tu diagnóstico
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="/#ecosistema"
            data-testid="hero-ecosistema-btn"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-rc-border hover:border-rc-sage/50 text-stone-200 transition-colors"
          >
            Cómo funciona el ecosistema
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.6 }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-rc-border/60 border border-rc-border rounded-xl overflow-hidden max-w-3xl"
        >
          {BADGES.map((b) => (
            <div key={b.k} className="bg-rc-bg/80 backdrop-blur p-5">
              <div className="font-serif text-xl text-stone-100">{b.k}</div>
              <div className="mt-1 text-xs text-stone-500 leading-snug">{b.v}</div>
            </div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
};
